import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export default function BookingAction() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  const id = searchParams.get("id");
  const action = searchParams.get("action");
  const token = searchParams.get("token");

  useEffect(() => {
    if (!id || !action || !token) {
      navigate("/booking-response?status=invalid", { replace: true });
      return;
    }

    const processBooking = async () => {
      try {
        const functionUrl = `https://${import.meta.env.VITE_SUPABASE_PROJECT_ID}.supabase.co/functions/v1/handle-booking-response?id=${encodeURIComponent(id)}&action=${encodeURIComponent(action)}&token=${encodeURIComponent(token)}`;

        const res = await fetch(functionUrl, {
          method: "GET",
          headers: { "X-Source": "frontend" },
          redirect: "manual",
        });

        const data = await res.json();

        const params = new URLSearchParams({ status: data.status || "error" });
        if (data.booking) {
          params.set("name", data.booking.name || "");
          params.set("date", data.booking.date || "");
          params.set("time", data.booking.time || "");
          params.set("guests", String(data.booking.guests || ""));
        }

        navigate(`/booking-response?${params.toString()}`, { replace: true });
      } catch (e) {
        console.error("BookingAction error:", e);
        setError("Kunde inte behandla bokningen. Försök igen.");
      }
    };

    processBooking();
  }, [id, action, token, navigate]);

  return (
    <>
      <Helmet>
        <title>Bearbetar bokning – Currylicious Yum Yum</title>
        <meta name="description" content="Behandlar din förfrågan för bordsbokning hos Currylicious Yum Yum. Vi uppdaterar din bokningsstatus baserat på din e-postbekräftelse." />
        <meta name="robots" content="noindex, nofollow" />
        <link rel="canonical" href="https://www.currylicious.se/booking-action" />
        <meta property="og:title" content="Bearbetar bokning – Currylicious Yum Yum" />
        <meta property="og:description" content="Behandlar din förfrågan för bordsbokning hos Currylicious Yum Yum. Vi uppdaterar din bokningsstatus baserat på din e-postbekräftelse." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.currylicious.se/booking-action" />
      </Helmet>
      <div
      style={{
        fontFamily: '"Georgia", serif',
        background: "#0a0a0a",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        padding: 20,
        backgroundImage:
          "radial-gradient(ellipse at top, rgba(212,168,75,0.06) 0%, transparent 60%)",
      }}
    >
      <div style={{ textAlign: "center", maxWidth: 420 }}>
        <h1 className="sr-only">Behandlar bokning</h1>
        <div
          style={{
            fontSize: 28,
            fontWeight: 700,
            background: "linear-gradient(135deg, #d4a84b, #f0d78c, #d4a84b)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
            letterSpacing: 3,
            textTransform: "uppercase" as const,
            marginBottom: 32,
          }}
        >
          Currylicious
        </div>

        {error ? (
          <div>
            <div style={{ fontSize: 48, marginBottom: 16 }}>⚠️</div>
            <p style={{ color: "#b0b0b0", fontSize: 15 }}>{error}</p>
            <button
              onClick={() => window.location.reload()}
              style={{
                marginTop: 20,
                padding: "10px 28px",
                background: "#d4a84b",
                color: "#1a1a1a",
                border: "none",
                borderRadius: 8,
                fontWeight: "bold",
                fontSize: 13,
                letterSpacing: 1,
                cursor: "pointer",
                fontFamily: '"Georgia", serif',
              }}
            >
              FÖRSÖK IGEN
            </button>
          </div>
        ) : (
          <div>
            <div
              style={{
                width: 56,
                height: 56,
                border: "3px solid #3d3220",
                borderTopColor: "#d4a84b",
                borderRadius: "50%",
                margin: "0 auto 24px",
                animation: "spin 1s linear infinite",
              }}
            />
            <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
            <p style={{ color: "#d4a84b", fontSize: 16, letterSpacing: 1 }}>
              Behandlar bokningen...
            </p>
            <p style={{ color: "#8a7340", fontSize: 12, marginTop: 8 }}>
              Vänta medan vi uppdaterar bokningsstatus
            </p>
          </div>
        )}
      </div>
      </div>
    </>
  );
}
